module.exports = __webpack_public_path__ + "img/img17.d8ec9af9.png";